<script setup lang="ts">
import type { PropType } from 'vue';

defineProps({
  variant: {
    type: String as PropType<'primary' | 'secondary' | 'white' | 'black'>,
    required: false,
    default: 'primary',
  },
});
</script>

<template>
  <svg
    class="brand-icon"
    :class="[`brand-icon--${variant}`]"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 223.38 294.6">
    <polygon points="102 196.42 149.22 98.2 223.38 98.2 173.38 196.42 223.38 294.6 149.22 294.6 102 196.42" />
    <polygon points=".59 0 50.35 98.2 0 294.6 74.19 294.6 121.73 98.2 74.74 0 .59 0" />
  </svg>
</template>

<style>
.brand-icon {
  &.brand-icon--primary {
    fill: var(--color-kc-primary);
  }

  &.brand-icon--secondary {
    fill: var(--color-secondary);
  }

  &.brand-icon--white {
    fill: var(--color-white);
  }

  &.brand-icon--black {
    fill: var(--color-black);
  }
}
</style>
